import OnePageCheckoutStateExt from "@DSG/Store/Pages/OnePageCheckoutExt/OnePageCheckoutStateExt";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: OnePageCheckoutStateExt = {
    editableNotes: "",
   firstName:"",
   lastName:"",
   phoneNumber:"",
   emailAddress:"",
   pickupTime:"",
   deliveryTime:"",
   jobName:"",
   pickupType:"",
   isPickUpSelected:"",
   isDeliveryAddressSelected:"-1",
   isPaymentDetailsValid:"false",
   isBillToAddressValid:"false",
   useOneTimeAddress:false,
   OneTimeShipToId:""

};

const reducer = {
    // PRFT Custom Code - START
    "Pages/OnePageCheckout/SetOrderNotes":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { orderNotes: string },
    )=>{
        draft.editableNotes = action.orderNotes;
    },

    "Pages/OnePageCheckout/SetFirstName":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { firstName: string },
    )=>{
        draft.firstName = action.firstName;
    },

    "Pages/OnePageCheckout/SetLastName":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { lastName: string },
    )=>{
        draft.lastName = action.lastName;
    },

    "Pages/OnePageCheckout/SetPhone":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { phone: string },
    )=>{
        draft.phoneNumber = action.phone;
    },
    "Pages/OnePageCheckout/SetEmailAddress":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { emailAddress: string },
    )=>{
        draft.emailAddress = action.emailAddress;
    },
    "Pages/OnePageCheckout/SetJobName":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { jobName: string },
    )=>{
        draft.jobName = action.jobName;
    },

    "Pages/OnePageCheckout/SetOneTimeShipToId":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { OneTimeShipToId: string },
    )=>{
        draft.OneTimeShipToId = action.OneTimeShipToId;
    },
    "Pages/OnePageCheckout/SetPickUpTime":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { pickupTime: string },
    )=>{
        draft.pickupTime = action.pickupTime;
    },

     "Pages/OnePageCheckout/SetDeliveryTime":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { deliveryTime: string },
     )=>{
        draft.deliveryTime = action.deliveryTime;
    },

    "Pages/OnePageCheckout/SetPickUpType":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { pickupType: string },
    )=>{

        if(!action.pickupType){
            return;
        }
        draft.pickupType = action.pickupType;
    },

    "Pages/OnePageCheckout/SetIsPickUpSelected":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { isPickUpSelected: string },
    )=>{

        if(!action.isPickUpSelected){
            return;
        }
        draft.isPickUpSelected = action.isPickUpSelected;
    },

    "Pages/OnePageCheckout/SetIsDeliveryAddressSelected":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { isDeliveryAddressSelected: string },
    )=>{
        if(!action.isDeliveryAddressSelected){
            return;
        }
        draft.isDeliveryAddressSelected = action.isDeliveryAddressSelected;
    },

    "Pages/OnePageCheckout/SetIsPaymentDetailsValid":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { isPaymentDetailsValid: string },
    )=>{
        if(!action.isPaymentDetailsValid){
            return;
        }
        draft.isPaymentDetailsValid = action.isPaymentDetailsValid;
    },
    "Pages/OnePageCheckout/SetIsBillToAddressValid":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { isBillToAddressValid: string },
    )=>{
        if(!action.isBillToAddressValid){
            return;
        }
        draft.isBillToAddressValid = action.isBillToAddressValid;
    },

    "Pages/OnePageCheckout/ResetForm": () => {
        return initialState;
    },

    "Pages/OnePageCheckout/SetUseOneTimeAddress": (
        draft: Draft<OnePageCheckoutStateExt>,
        { useOneTimeAddress, shipTo }: { useOneTimeAddress: boolean; shipTo: ShipToModel | undefined },
    ) => {
        draft.useOneTimeAddress = useOneTimeAddress;
        draft.useBillingAddress = false;

        if (!shipTo) {
            return;
        }

        draft.shippingAddressFormState = {
            address: shipTo,
            formErrors: {},
        };
    },

    "Pages/OnePageCheckout/SetLastSelectedShipTo": (
        draft: Draft<OnePageCheckoutStateExt>,
        action: { shipTo: ShipToModel },
    ) => {
        draft.lastSelectedShippingAddress = action.shipTo;
        draft.useBillingAddress = false;
    },

    // "Pages/OnePageCheckout/SetShippingAddress": (
    //     draft: Draft<OnePageCheckoutStateExt>,
    //     action: { address: ShipToModel },
    // ) => {
    //     if (!draft.shippingAddressFormState) {
    //         return;
    //     }

    //     draft.shippingAddressFormState.address = action.address;
    // },
    "Pages/OnePageCheckout/SetShippingAddress": (
        draft: Draft<OnePageCheckoutStateExt>,
        action: { address: ShipToModel; validation?: any } // Accept validation as part of the action payload
    ) => {
        if (!draft.shippingAddressFormState) {
            return;
        }

        // Update the address
        draft.shippingAddressFormState.address = action.address;

        // If validation rules are provided in the action, update them
        if (action.validation) {
            draft.shippingAddressFormState.address.validation = action.validation;
        }
    },
    "Pages/OnePageCheckout/SetShippingAddressFormErrors": (
        draft: Draft<OnePageCheckoutStateExt>,
        action: { formErrors: { [key: string]: React.ReactNode } },
    ) => {
        if (!draft.shippingAddressFormState) {
            return;
        }
        draft.shippingAddressFormState.formErrors = action.formErrors;
    },
    // PRFT Custom code - END
};

const onePageCheckoutPageExtReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).onePageCheckoutStateExt = onePageCheckoutPageExtReducer;
type OnePageCheckoutExtReducers ={
    onepageCheckoutCustomReducer:typeof onePageCheckoutPageExtReducer;
};
export type onePageCheckoutCustom = Parameters<OnePageCheckoutExtReducers[keyof OnePageCheckoutExtReducers]>[1] | AnyAction;

